
define('ldsh!modules/editor/templates/property_boxes/page_jquery_selector', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-modal-content ed-opt-content ed-tab-content active">\n    <form action="" role="form">\n        <div class="col col-centered">\n            <div class="ed-form-group">\n                <label for="" data-i18n="editor.page.jQuerySelector"> </label>\n                <select\n                    class="ed-form-control ed-item-full js-jquery-selector-page"\n                    data-property="version" style="width: 340px;">\n                    ';
 for (var i = 0; i < jqueryAvailableVersions.length; i++) { ;
__p += '\n                    <option value="' +
((__t = ( jqueryAvailableVersions[i].version )) == null ? '' : __t) +
'">' +
((__t = ( jqueryAvailableVersions[i].name )) == null ? '' : __t) +
'</option>\n                    ';
 } ;
__p += '\n                </select>\n            </div>\n        </div>\n    </form>\n</div>\n';

}
return __p
};});

